/* import __COLOCATED_TEMPLATE__ from './clinicians-list.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class RequestCliniciansList extends Component {
  @service session;
}
